module.exports = __webpack_public_path__ + "static/img/00415v.6c69079.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/00415v.jpg
// module id = 95lC
// module chunks = 1